// External practice-management billing helpers (Veradigm PM, ModMed).
//
// usesExternalPmBilling: the org posts charges into an external PM instead of
// Prism's Claim.MD pipeline (either integration). Sites that are specific to
// one PM (account numbers, batches, PM abbreviations) keep reading their own flag.
//
// pmTargetForLocation: client mirror of backend functions/resolve_pm_target —
// which PM an encounter at `locationId` posts to. ModMed wins for locations
// listed on the org's ModMed config; everything else goes to Veradigm PM when
// that flag is on; null = Prism's own claim flow. Whether the chosen PM is
// actually configured and active is checked separately via each store.
export function usesExternalPmBilling(settings) {
  const s = settings || {};
  return s.uses_veradigm_billing === true || s.uses_modmed_billing === true;
}

export function pmTargetForLocation(locationId, { settings, modmedLocationIds } = {}) {
  const s = settings || {};
  const loc = locationId ? String(locationId) : '';
  const ids = Array.isArray(modmedLocationIds) ? modmedLocationIds.map(String) : [];
  if (s.uses_modmed_billing === true && loc && ids.includes(loc)) return 'modmed';
  if (s.uses_veradigm_billing === true) return 'veradigm';
  return null;
}

export function pmTargetLabel(target) {
  if (target === 'modmed') return 'ModMed';
  if (target === 'veradigm') return 'Veradigm PM';
  return 'practice management system';
}
